import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './AIRevisionLoading.scss';

/**
 * AIRevisionLoading - Full-page loading overlay with bot mascot and rotating text
 * Used when waiting for AI revision conversations to be created
 */
function AIRevisionLoading({ isVisible = false }) {
  const { t } = useTranslation('chatbot');
  const loadingTexts = t('ai_revision_loading_texts', { returnObjects: true }) || [];
  const [textIndex, setTextIndex] = useState(() => Math.floor(Math.random() * loadingTexts.length));

  // Rotate text every 2.5 seconds
  useEffect(() => {
    if (!isVisible || loadingTexts.length === 0) return;

    const interval = setInterval(() => {
      setTextIndex((prev) => (prev + 1) % loadingTexts.length);
    }, 2000);

    return () => clearInterval(interval);
  }, [isVisible, loadingTexts.length]);

  // Reset to random text when becoming visible
  useEffect(() => {
    if (isVisible && loadingTexts.length > 0) {
      setTextIndex(Math.floor(Math.random() * loadingTexts.length));
    }
  }, [isVisible, loadingTexts.length]);

  if (!isVisible) return null;

  return (
    <div className="ai-revision-loading">
      <div className="ai-revision-loading__backdrop" />
      <div className="ai-revision-loading__content">
        <div className="ai-revision-loading__bot-container">
          <div className="ai-revision-loading__stars">
            <span className="ai-revision-loading__star ai-revision-loading__star--1">✦</span>
            <span className="ai-revision-loading__star ai-revision-loading__star--2">✦</span>
          </div>
          <img
            src="/images/bot/ai_bot_search.png"
            alt="AI Bot"
            className="ai-revision-loading__bot"
          />
        </div>
        <p className="ai-revision-loading__text">{loadingTexts[textIndex]}</p>
      </div>
    </div>
  );
}

AIRevisionLoading.propTypes = {
  isVisible: PropTypes.bool,
};

export default AIRevisionLoading;
